import React, { useMemo, useState } from "react";
import { Box } from "@mui/material";
import EditableTable from "../../../../../../components/Tables/EditableTable";

const buildColumns = (rows, schema = []) => {
  const orderedKeys = [];

  schema.forEach((column) => {
    if (column?.name && column.name !== "id" && !orderedKeys.includes(column.name)) {
      orderedKeys.push(column.name);
    }
  });

  (rows || []).forEach((row) => {
    Object.keys(row || {}).forEach((key) => {
      if (key !== "id" && !orderedKeys.includes(key)) orderedKeys.push(key);
    });
  });

  return [
    { accessorKey: "id", header: "ID" },
    ...orderedKeys.map((key) => ({
      id: key,
      accessorFn: (row) => row[key],
      header: key.replace(/_/g, " "),
    })),
  ];
};

export default function EditingTables({
  selectedTable,
  dbName,
  tableApi,
  enableEdit = true,
}) {
  const [columns, setColumns] = useState([{ accessorKey: "id", header: "ID" }]);

  const tableApiAdapter = useMemo(
    () => ({
      getItems: async () => {
        if (!selectedTable || !dbName || !tableApi?.getItems) return [];

        const [rows, schema] = await Promise.all([
          tableApi.getItems(selectedTable, dbName),
          tableApi.getColumns
            ? tableApi.getColumns(selectedTable, dbName)
            : Promise.resolve([]),
        ]);

        const normalizedRows = rows ?? [];
        setColumns(buildColumns(normalizedRows, schema));
        return normalizedRows;
      },
      updateItem: async (item) => {
        if (!tableApi?.updateItem) return item;
        await tableApi.updateItem(item, selectedTable, dbName);
        return item;
      },
    }),
    [dbName, selectedTable, tableApi]
  );

  if (!selectedTable || !dbName) return null;

  return (
    <Box sx={{ width: "100%" }}>
      <EditableTable
        key={`${dbName}:${selectedTable}`}
        name={selectedTable}
        columns={columns}
        displayMode="modal"
        api={tableApiAdapter}
        enableEditing={enableEdit}
        enableCreate={false}
        initialData={{}}
        parentId={`${dbName}:${selectedTable}`}
        enableDelete={false}
        additionalProps={{
          layoutMode: "grid",
          defaultColumn: {
            minSize: 20,
            size: Math.max(60, Math.floor(900 / Math.max(columns.length, 1))),
          },
        }}
      />
    </Box>
  );
}
